import { render } from "./UserReplacementMoc.vue?vue&type=template&id=604f0958&scoped=true"
import script from "./UserReplacementMoc.vue?vue&type=script&lang=js"
export * from "./UserReplacementMoc.vue?vue&type=script&lang=js"

import "./UserReplacementMoc.vue?vue&type=style&index=0&id=604f0958&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-604f0958"]])

export default __exports__